export default "__VITE_ASSET__Bqg_f9A7__"